import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/logo.png'


import { routes } from "@/router/routes";
import { useRouter } from "vue-router";
import { computed, ref } from "vue";
import { useLoginUserStore } from "@/store/userStore";
import checkAccess from "@/access/checkAccess";
import { useDarkModeStore } from "@/store/themeStore"; // 引入主题 store
import {
  IconMoonFill,
  IconPoweroff,
  IconSunFill,
  IconUser,
} from "@arco-design/web-vue/es/icon"; // 引入图标
import { userLogoutUsingPost } from "@/api/userController"; // 引入退出登录 API
import { Message } from "@arco-design/web-vue"; // 引入消息提示


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const themeStore = useDarkModeStore(); // 初始化 store

const loginUserStore = useLoginUserStore();

const router = useRouter();
//当前选择的菜单选项
const selectedKeys = ref(["/"]);
//跳转时，自动更新选择的菜单选项
router.afterEach((to, from, failure) => {
  selectedKeys.value = [to.path];
});

//展示在菜单栏的路由数据
const visibleRoutes = computed(() => {
  return routes.filter((item) => {
    if (item.meta?.hideInMenu) {
      return false;
    } // 根据权限过滤菜单
    if (!checkAccess(loginUserStore.loginUser, item.meta?.access as string)) {
      return false;
    }
    return true;
  });
});

// 路由跳转事件
const doMenuClick = (key: string) => {
  router.push({
    path: key,
  });
};
// 退出登录逻辑
const doLogout = async () => {
  try {
    const res = await userLogoutUsingPost();
    if (res.data.code === 0) {
      Message.success("退出登录成功");
      // 【新增】重置主题为默认（亮色）
      themeStore.resetTheme();
      // 清除本地用户状态
      loginUserStore.setLoginUser({ userName: "未登录" });
      // 跳转到登录页或首页
      router.push("/");
    } else {
      Message.error("退出失败：" + res.data.message);
    }
  } catch (e) {
    Message.error("退出失败，请重试");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    id: "globalHeader",
    align: "center",
    wrap: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { flex: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "horizontal",
            onMenuItemClick: doMenuClick,
            "selected-keys": selectedKeys.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "0",
                style: { padding: 0, marginRight: '38px' },
                disabled: ""
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "titlebar" }, [
                    _createElementVNode("img", {
                      class: "logo",
                      src: _imports_0
                    }),
                    _createElementVNode("div", { class: "title" }, "AIdati")
                  ], -1)
                ]))]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "120px" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, { size: 15 }, {
            default: _withCtx(() => [
              (!_unref(loginUserStore).loginUser.id)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    href: "/user/login"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("登录", -1)
                    ]))]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_a_avatar, {
                      size: 24,
                      "image-url": _unref(loginUserStore).loginUser.userAvatar
                    }, null, 8, ["image-url"]),
                    _createVNode(_component_a_dropdown, null, {
                      content: _withCtx(() => [
                        _createVNode(_component_a_doption, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/user/edit')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IconUser)),
                            _cache[3] || (_cache[3] = _createTextVNode(" 个人信息 ", -1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_doption, { onClick: doLogout }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IconPoweroff)),
                            _cache[4] || (_cache[4] = _createTextVNode(" 退出登录 ", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(loginUserStore).loginUser.userName ?? "请输入用户名"), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      shape: "circle",
                      type: "text",
                      onClick: _unref(themeStore).toggleTheme,
                      style: { marginRight: '10px' }
                    }, {
                      default: _withCtx(() => [
                        (!_unref(themeStore).isDark)
                          ? (_openBlock(), _createBlock(_unref(IconMoonFill), { key: 0 }))
                          : (_openBlock(), _createBlock(_unref(IconSunFill), { key: 1 }))
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})